export const askFlashDiceMessagesReducer = (state, action) => {
  switch (action.type) {
    case "ADD_MESSAGE":
      return [...state, action.message];
    case "UPDATE_MESSAGE": {
      // For relationship messages, prefer complete format over summaries
      return state.map((msg) => {
        if (msg.id === action.id) {
          // Check if this is a relationship message by checking content
          const isRelationshipMessage = (action.content.includes('relationship') && action.content.includes('->')) ||
                                       (msg.content?.includes('relationship') && msg.content?.includes('->'));
          
          if (isRelationshipMessage) {
            const newHasComplete = action.content.includes('DIRECT') || action.content.includes('INDIRECT');
            const existingHasComplete = msg.content?.includes('DIRECT') || msg.content?.includes('INDIRECT');
            
            // Only update if:
            // 1. New content has complete format and existing doesn't, OR
            // 2. Both have complete format and new is longer (more complete), OR
            // 3. Neither has complete format and new is longer
            if (newHasComplete && !existingHasComplete) {
              // New has complete format, existing doesn't - update
              return { ...msg, content: action.content };
            } else if (newHasComplete === existingHasComplete) {
              // Both same type - prefer longer (more complete) content
              if (action.content.length > (msg.content?.length || 0)) {
                return { ...msg, content: action.content };
              }
              // New is shorter or same - keep existing
              return msg;
            } else {
              // Existing has complete format, new doesn't - keep existing
              return msg;
            }
          }
          // For non-relationship messages, always update
          return { ...msg, content: action.content };
        }
        return msg;
      });
    }
    case "SET_MESSAGE_NLP_ID": {
      const { messageId, nlp_message_id, model_id } = action;
      return state.map((msg) =>
        msg.id === messageId
          ? { ...msg, nlp_message_id, ...(model_id != null && { model_id }) }
          : msg
      );
    }
    case "SET_MESSAGE_FEEDBACK": {
      const { nlp_message_id, feedback } = action;
      return state.map((msg) =>
        msg.nlp_message_id === nlp_message_id ? { ...msg, feedback } : msg
      );
    }
    case "ADD_THINKING_MESSAGE": {
      const beforeIndex = state.findIndex((m) => m.id === action.beforeId);
      if (beforeIndex >= 0) {
        const newState = [...state];
        newState.splice(beforeIndex, 0, action.message);
        return newState;
      }
      return [...state, action.message];
    }
    case "RESET":
      return [];
    case "REMOVE_MESSAGE": {
      const { messageId } = action;
      return state.filter((msg) => msg.id !== messageId);
    }
    default:
      return state;
  }
};

